import React, { useMemo, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RootState } from "store";
import { IResourceTableProps } from "types";
import { ActionMenu } from "./ActionMenu";
import NoData from "./NoData";
import Confirmation from "../Confirmation";
import { Filteration } from "../Filteration";
import { updateFilters } from "store/state/stateSlice";
import { Paginator } from "../Pagination";
import "styles/primereact-Table.css";
import "styles/pagination.css";
import { Loading } from "components/base";
export default function ResourceTable(props: IResourceTableProps) {
  const dispatch = useDispatch();

  const { filters, page, perPage, first } = useSelector(
    (state: RootState) => state.state
  );

  //states
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [archiveVisible, setArchiveVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [expandedRows, setExpandedRows] = useState<any>(null);

  const actionTemplate = (row: any) => {
    return (
      <ActionMenu
        row={row}
        viewRoute={props.viewRoute}
        editRoute={props.editRoute}
        viewModal={props.viewModal}
        modalData={props.modalData}
        editModal={props.editModal}
        setSelectedItem={setSelectedItem}
        setDeleteVisible={setDeleteVisible}
        setArchiveVisible={setArchiveVisible}
        deleteAction={props.deleteAction}
        archiveAction={props.archiveAction}
        policies={props?.policies}
      />
    );
  };

  //columns
  const tableColumns = props.columns?.map((col: any, i: any) => {
    return (
      <Column
        key={i}
        field={col.field}
        header={col.header}
        body={col.body}
        style={col.style}
        selectionMode={col.selection}
        editor={col.editor}
        onCellEditComplete={col.onCellEditComplete}
        headerStyle={col.headerStyle}
        align={col.align ? col.align : "left"}
        alignHeader={col.headerAlign ? col.headerAlign : "left"}
      />
    );
  });

  //with action menu
  const resourceColumns = useMemo(() => {
    return [
      props.allowExpansion && (
        <Column
          expander={props.allowExpansion}
          style={{ width: "4rem" }}
        />
      ),
      ...tableColumns,
      props.actionMenu && (
        <Column
          key='actions'
          header='Actions'
          body={actionTemplate}
        />
      ),
    ];
  }, [props.allowExpansion, props.actionMenu, tableColumns]);

  //cell class
  const CellClass = () => {
    return "hover:text-indigo-900";
  };

  //use effect for dispatch actions
  useLayoutEffect(() => {
    if (props?.loadData) {
      dispatch(props?.loadData({ perPage, page, filters }));
    }
  }, [
    dispatch,
    perPage,
    page,
    first,
    filters?.query,
    // filters?.reference,
    filters?.branchId,
  ]);

  useLayoutEffect(() => {
    dispatch(updateFilters(props?.enableFilters));
  }, [dispatch]);

  //
  useMemo(() => {
    if (props?.createSelector || props?.updateSelector) {
      if (props?.editModal) {
        props.editModal(false);
        if (props?.loadData) {
          setTimeout(() => {
            dispatch(props?.loadData({ perPage, page, filters }));
          }, 500);
        }
      }
      if (props?.createModal) {
        props.createModal(false);
        if (props?.loadData) {
          setTimeout(() => {
            dispatch(props?.loadData({ perPage, page, filters }));
          }, 500);
        }
      }
    }
  }, [props?.createSelector, props?.updateSelector]);

  //
  const onDeleteItem = React.useCallback(
    async (item: any) => {
      await dispatch(props.deleteAction({ item: item }));
      if (props?.loadData) {
        setTimeout(() => {
          dispatch(props?.loadData({ perPage, page, filters }));
        }, 500);
      }
      setDeleteVisible(false);
    },
    [dispatch, perPage, page, first, filters?.query, filters?.category?.id]
  );

  //
  const onArchiveItem = React.useCallback(async (item: any) => {
    await dispatch(props.archiveAction({ item: item }));
    await dispatch(props?.loadData({ perPage, page }));
    setArchiveVisible(false);
  }, []);

  return (
    <React.Fragment>
      <div className='py-2'>
        {props.tableMenu && (
          <Filteration
            createRoute={props.createRoute}
            createModal={props.createModal}
            breadCrumbRoutes={props.breadCrumbRoutes}
          />
        )}
      </div>
      <div className='overflow-hidden shadow-sm flex justify-between flex-col relative'>
        <DataTable
          value={props?.data}
          dataKey='id'
          breakpoint='960px'
          emptyMessage={NoData}
          className='text-[12px] font-medium'
          cellClassName={CellClass}
          rowHover
          // loading={props.loading}
          lazy
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={props.rowExpansionTemplate}
          expandedRows={expandedRows}
          editMode={props?.editMode}
        >
          {resourceColumns}
        </DataTable>
        {props.isPagination && (
          <div className='flex items-center w-full'>
            <Paginator paginationOption={props?.pagination} />
          </div>
        )}
        {props.loading && (
          <div className='absolute w-full h-full flex justify-center items-center'>
            <Loading />
          </div>
        )}
      </div>

      <Confirmation
        setVisible={setDeleteVisible}
        visible={deleteVisible}
        message='Are you sure you want to perform this action?'
        accept={() => onDeleteItem(selectedItem)}
      />

      <Confirmation
        setVisible={setArchiveVisible}
        visible={archiveVisible}
        message='Are you sure you want to perform this action?'
        accept={() => onArchiveItem(selectedItem)}
      />
    </React.Fragment>
  );
}
